import React from 'react';

export const TrashIcon = () => (
    <svg width="13" height="15" viewBox="0 0 13 15" >
    <g stroke="#2D2D2D" strokeWidth=".81" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(1 2.405)">
            <rect width="11" height="2.108" rx="1.054"/>
            <path d="M1.1 2.108h8.8v8.131c0 .749-.492 1.356-1.1 1.356H2.2c-.608 0-1.1-.607-1.1-1.356V2.11zM4.033 4.216v4.216M6.967 4.216v4.216"/>
        </g>
        <path d="M5.033 2.405h3.3V1.201C8.333 1.09 8.15 1 7.921 1H5.446c-.228 0-.413.09-.413.2v1.205z"/>
    </g>
</svg>
)

export const DownloadIcon = () => (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 12.8235V13.8235C17.5 15.2236 17.5 15.9237 17.2275 16.4585C16.9878 16.9289 16.6054 17.3113 16.135 17.551C15.6002 17.8235 14.9001 17.8235 13.5 17.8235H6.5C5.09987 17.8235 4.3998 17.8235 3.86502 17.551C3.39462 17.3113 3.01217 16.9289 2.77248 16.4585C2.5 15.9237 2.5 15.2236 2.5 13.8235V12.8235M14.1667 8.65682L10 12.8235M10 12.8235L5.83333 8.65682M10 12.8235V2.82349" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)